import React from 'react';
import { ChangelogTemplate } from 'components';

export const ChangelogPage = ({ t, ...props }) => (
  <ChangelogTemplate t={t} title={t('COMMON.CHANGELOG')} {...props} />
);
